// extracted by mini-css-extract-plugin
module.exports = {"categoryTags":"styles_categoryTags__YOyUY","header":"styles_header__8qs49","footer":"styles_footer__I8mBw","filtersButton":"styles_filtersButton__P62RF"};